export default __webpack_public_path__ + "static/media/image.adf26f36.png";